import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Room } from '@core/models/Room/Room.model';
import { selectRoomDetailById } from '@store/hotel-availability/hotel-availability.selectors';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { DeviceService, ReqService } from '@core/services';
import { ModalRoomComponent } from '@modals/room/room.component';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog } from '@am/moebius';
import { RoomHeaderComponent } from '../room-header/room-header.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'am-room-information',
    templateUrl: './room-information.component.html',
    styleUrls: ['./room-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        RoomHeaderComponent,
        AsyncPipe,
    ],
})
export class RoomInformationComponent {
  public readonly PLACEHOLDER = 'PLACEHOLDER';

  private _room: Room;
  public roomImage$: Observable<string>;
  public children = 0;
  public imageUnavailable = true;

  @Input()
  public lastRoom = false;

  @Input()
  public hideImage = false;

  @Input()
  public useCompactStyle = false;

  private roomDetail: any;

  constructor(
    protected readonly store: Store<AppState>,
    protected readonly contextService: ReqService,
    protected readonly deviceService: DeviceService,
    private readonly dialog: MbDialog,
  ) {}

  @Input()
  public set room(value: Room) {
    this._room = value;
    this.children = this.room.children.length;
    this.roomImage$ = this.store
      .select(selectRoomDetailById, { roomId: this.room.id })
      .pipe(
        map((detail) => {
          if (detail === undefined) {
            return this.PLACEHOLDER;
          }
          this.roomDetail = detail;
          return detail.images && (detail.images as any[]).length > 0
            ? detail.images[0].url
            : this.PLACEHOLDER;
        }),
        tap((imgSrc: string) => {
          this.imageUnavailable = imgSrc === this.PLACEHOLDER;
        }),
      );
  }

  public showRoomDetails() {
    if (this.deviceService.isDesktop()) {
      const dialogData = {
        room: this.roomDetail,
        isDisney: this.contextService.isDisneyHotel(),
      };
      this.dialog.open(ModalRoomComponent, {
        ...dialogConfig,
        closeBtn: true,
        size: 'lg',
        dialogData: dialogData,
      });
    }
  }

  public onImageErrorHandler(): void {
    this.imageUnavailable = true;
  }

  public get room(): Room {
    return this._room;
  }

  public get roomName(): string {
    return this.contextService.isDisneyHotel()
      ? this._room.parsedName
      : this._room.room_description.description;
  }
}
